var WDN__DateFormatter = function(date) {
  if (!date) { return false; }
  var year = date.getFullYear();
  var dayOfMonth = date.getDate();
  var month = date.getMonth() + 1;

  if (dayOfMonth < 10) {
    dayOfMonth = "0" + dayOfMonth;
  }

  if (month < 10) {
    month = "0" + month;
  }

  var formattedDates = [year, month, dayOfMonth];

  return formattedDates.join('-');
} 
 

class FormInputCartAttribute {
  constructor(name, value, type = "hidden") {
    this.element = document.createElement("input");
    this.type = type;
    this.name = name;
    this.value = value;
    this.init();
  }


  init() {
    this.element.name = "attributes[" + this.name + "]";
    this.element.type = this.type;
    this.element.value = this.value;
  }
}


class CartFormAttributes {
  constructor(form_selector) {
    this.form = document.querySelector(form_selector);
    if (!this.form) { return; }
    
    this.fieldList = [];
    this.init();
  }

  buildFirstOrderDate() {
    this.dateNow = new Date(Date.now());
    this.dateNowFormatted = WDN__DateFormatter(this.dateNow);
    this.fieldList.push(new FormInputCartAttribute("first_order_created_date", this.dateNowFormatted));
  }

  readCameraDeliveryDays() {
    this.cameraDeliveryTimeDayElem = document.querySelector('input[name="camera_delivery_time_days"]');
    this.cameraDeliveryTimeDays = parseInt(this.cameraDeliveryTimeDayElem.value);
  }

  buildPromisedDeliveryDate() {
    this.readCameraDeliveryDays();
    this.cameraDeliveryTimeDaysMs = this.cameraDeliveryTimeDays  * 24 * 60 * 60 * 1000;

    this.dateDelivery = new Date(Date.now() + this.cameraDeliveryTimeDaysMs);
    this.dateDeliveryFormatted = WDN__DateFormatter(this.dateDelivery);

    this.fieldList.push(new FormInputCartAttribute("expected_ship_date", this.dateDeliveryFormatted));
  }

  buildFieldList() {
    this.buildFirstOrderDate();
    this.buildPromisedDeliveryDate();
  }

  addFieldsToForm() {
    this.fieldListToRender = new DocumentFragment();
    this.fieldList.forEach((item) => {
      this.fieldListToRender.append(item.element);
    });

    this.form.append(this.fieldListToRender);
  }

  init() {
    this.buildFieldList();
    this.addFieldsToForm();
  }
}

new CartFormAttributes("[data-main-pricing-form]");